// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';

// Styles
import './form-updated.scss';

export default class FormUpdated extends Component {
    componentWillUnmount() {
        const {formSubmitReset} = this.props;

        formSubmitReset();
    }

    getClass() {
        const {absolutePositioned, className} = this.props;

        return classnames(
            {
                'form-updated': true,
                'form-updated_absolute': absolutePositioned,
            },
            className
        );
    }

    render() {
        const {editing = true, formLabel, formSubmitReset, successMessage} = this.props;

        return (
            <div className={this.getClass()}>
                <div className="form-updated--message">
                    {!successMessage
                        ? `${formLabel || 'Record'} successfully ${editing ? 'updated' : 'created'}`
                        : successMessage}
                </div>
                <Button className="form-updated--button" onClick={formSubmitReset}>
                    Ok
                </Button>
            </div>
        );
    }
}

FormUpdated.propTypes = {
    absolutePositioned: PropTypes.bool,
    className: PropTypes.string,
    editing: PropTypes.bool,
    formLabel: PropTypes.string,
    formSubmitReset: PropTypes.func.isRequired,
    successMessage: PropTypes.string,
};
